import React from 'react';
import type { TNotificationsContextType } from '@shared/notifications/lib/types';
export const NotificationsContext = React.createContext<TNotificationsContextType>({
  notifications: new Map(),
  clearNotifications() {},
  closeNotification() {},
  showNotification() {}
});
export function useNotifications(): TNotificationsContextType {
  return React.useContext(NotificationsContext);
}